<script setup lang="ts">
import { AccordionRoot, type AccordionRootEmits, type AccordionRootProps } from 'reka-ui'
import { cn } from '@/lib/utils'
import type { HTMLAttributes } from 'vue'

const props = defineProps<AccordionRootProps & { class?: HTMLAttributes['class'] }>()
const emits = defineEmits<AccordionRootEmits>()
</script>

<template>
    <AccordionRoot v-bind="{ ...props, class: undefined }" :class="cn(props.class)" @update:model-value="(v) => emits('update:modelValue', v)">
        <slot />
    </AccordionRoot>
</template>
